import React , { Component } from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';

import {fetch_policy} from '../../actions/aboutPolicy/policyAction';

import ContentFirmAndPolicySty from './contentFirmAndPolicy.module.css';

import firmNormalIcon from '../../images/firm_normal_icon.png';
import policyNormalIcon from '../../images/policy_normal_icon2.png';
import firmSelectlIcon from '../../images/firm_select_icon.png';
import policySelectIcon from '../../images/policy_select_icon2.png';
import {getFirmIntro} from './service';


const menuData=[
    {key:0, itemNormalIcon:firmNormalIcon,itemSelectIcon:firmSelectlIcon, itemTitle:'企业简介'},
    {key:1, itemNormalIcon:policyNormalIcon,itemSelectIcon:policySelectIcon, itemTitle:'政策咨询'}
];

const policyInfoData=[
    {key:0, infoType:'高薪', title:'[北京]2018年第二批拟认定高新技术企业名单'},
    {key:1, infoType:'资金', title:'中国技术创业协会科技财税服务联盟成立大服务盟盟成立大服务盟...'},
    {key:2, infoType:'知识', title:'商标注册申请常见问题汇总盟成立大服务盟'},
    {key:3, infoType:'高薪', title:'[北京]2018年第二批拟认定高新技术企业名单'},
    {key:4, infoType:'资金', title:'中国技术创业协会科技财税服务联盟成立大服务盟盟成立大服务盟...'},
    {key:5, infoType:'知识', title:'商标注册申请常见问题汇总盟成立大服务盟'},
    {key:6, infoType:'高薪', title:'[北京]2018年第二批拟认定高新技术企业名单'},
];

class ContentFirmAndPolicy extends Component{

    state={
        selectedItem:'企业简介',
        selectedIndex:0,
        firmIntro:null,
    }

    constructor(props){
        super(props);
        this.menuItemOnClick=this.menuItemOnClick.bind(this);
        this.GetFirmProfileContent=this.GetFirmProfileContent.bind(this);
        this.GetPolicyInfo=this.GetPolicyInfo.bind(this);
        this.onContentChange=this.onContentChange.bind(this);
        this.onPolicyNewsItemClick=this.onPolicyNewsItemClick.bind(this);
        this.onPolicyMoreClick=this.onPolicyMoreClick.bind(this);
    }

    async componentDidMount() {
        const {data} = await getFirmIntro();
        data.list.map((item,index) => {
            if(item.id === 14 && item.title=== "公司简介")
               this.setState({firmIntro: item.value});
        })
    }

    menuItemOnClick=(selectedItem,selectedIndex)=>{
        // 如果没有政策解读数据，就显示默认的card
        if(this.props.policyData.length === 0){
            selectedItem=this.state.selectedItem;
            selectedIndex=this.state.selectedIndex;
        }
        this.setState({
            selectedIndex:selectedIndex,
            selectedItem:selectedItem
        });
    };

    GetFirmProfileContent=()=>{
        const firmNameText="北京经纬通达管理咨询有限公司";
        const firmOverviewText="多年来致力于从事税收筹划、高新企业认定、科技服务、财税服务、科技咨询、中小企业创业辅导等领域的咨询服务。先后为国内数千家企业、科研机构、院所等提供了一流的企业科研、财税等咨询服务，其中不乏全球500强企业和一些知名上市公司，尤具代表性的有中铁系统、城建系统、中建系统、市政系统等 公司拥有良好、广泛的合作伙伴关系，目前已与中关村国家自主创新示范区管委会及北京各园区管委会、北京市高新技术产业服务中心.. ";
        return (
            <div className={ContentFirmAndPolicySty.firmOverviewSty}>
                <div className={ContentFirmAndPolicySty.firmOverviewImgSty}></div>
                <div className={ContentFirmAndPolicySty.firmOverviewTextDivSty} dangerouslySetInnerHTML={{__html:this.state.firmIntro}}>
                    {/* <span>{firmNameText}</span>
                    {firmOverviewText}  */}
                </div> 

            </div>
        );
    }

    // 政策咨询内的新闻点击响应事件
    onPolicyNewsItemClick=(cate_id,cate_desc,id)=>{

        window.scrollTo(0,400)
        // // 开始跳转到政策新闻详情页
        // this.props.history.push('/policy/detail_policy/'+id);

        this.props.history.push(`/policy/more/${cate_id}/${cate_desc}/detail/${id}`);
    }

    // 政策咨询的更多响应事件
    onPolicyMoreClick=()=>{
        if(this.state.selectedIndex==1){
            this.props.history.push({pathname:`/policy/more/1`});
            window.scrollTo(0,400)
        }else if(this.state.selectedIndex==0){
            this.props.history.push({pathname:`/about`});
            window.scrollTo(0,300)
        }

    }

    GetPolicyInfo=()=>{
        const gaoxinFontColor={color:'#1CC6D5'};
        const zijinFontColor={color:'#279AF3'};
        const zhishiFontColor={color:'#EFA634'};
        const zixunFontColor={color:'#9933CC'};

        // console.log('首页政策组件查看props')
        // console.log(this.props)
        // ''.includes()
        let policyInfoLis=this.props.policyData.map((item,index)=>{
            // item.id   item.cate_id
            let infoTypeFontColor={color:'#000'};
            let infoType=undefined;
            if(item.cate_desc.includes('高新')){
                infoTypeFontColor=gaoxinFontColor;
                infoType='高新';
            }
            else if(item.cate_desc.includes('资金')){
                infoTypeFontColor=zijinFontColor;
                infoType='资金'
            }
            else if(item.cate_desc.includes('知识')){
                infoTypeFontColor=zhishiFontColor;
                infoType='知识'
            }else if(item.cate_desc.includes('资讯')){
                infoTypeFontColor=zixunFontColor;
                infoType='资讯'
            }


            if(!item.cate_desc.includes('专题')){
                return(
                    <li onClick={()=>{this.onPolicyNewsItemClick(item.cate_id,item.cate_desc,item.id)}}>
                        <div className={ContentFirmAndPolicySty.policyInfoTypeSty} style={infoTypeFontColor}>{infoType}</div>
                        <div className={ContentFirmAndPolicySty.policyInfoTitleSty}><a>{item.title}</a></div>
                    </li>
                );
            }
        });

        return(
            <div className={ContentFirmAndPolicySty.policyInfoDivSty}>
                <div className={ContentFirmAndPolicySty.policyInfoLeftDivSty}>
                    <ul>
                        {policyInfoLis}
                    </ul>
                </div>
                <div className={ContentFirmAndPolicySty.policyInfoSplitLineSty}></div>
                <div className={ContentFirmAndPolicySty.policyInfoRightDivSty}>
                    <ul>
                        {policyInfoLis}
                    </ul>
                </div>
            </div>
        );
    }

    onContentChange=()=>{
        switch (this.state.selectedItem) {
            case '企业简介':
                return this.GetFirmProfileContent();
                break;
            case '政策咨询':
                return this.GetPolicyInfo();
                break;
            default:
                break;
        }
    }


    render(){
        const itemNormalSty={
            fontSize:'16px',
            fontFamily:'Microsoft YaHei',
            fontWeight:'400',
            color:'rgba(102,102,102,1)'
        };
        const itemSelectedSty={
            fontSize:'18px',
            fontFamily:'Microsoft YaHei',
            fontWeight:'bold',
            color:'rgba(6,42,114,1)',
            lineHeight:'18px',
        };
        let menuLis=menuData.map(({key,itemNormalIcon,itemSelectIcon,itemTitle})=>{
            let iconNormalSty={backgroundImage:`url(${itemNormalIcon})`};
            let iconSelectSty={backgroundImage:`url(${itemSelectIcon})`};
            if(this.props.policyData.length === 0 && key === 1) {
                return null;
            } else {
                return(
                    <li key={key}>
                        <div className={ContentFirmAndPolicySty.menuIconSty} style={this.state.selectedIndex==key?iconSelectSty:iconNormalSty} ></div>
                        <div className={ContentFirmAndPolicySty.menuTiltleSty}><a style={this.state.selectedIndex==key?itemSelectedSty:itemNormalSty} onClick={()=>{this.menuItemOnClick(itemTitle,key)}}>{itemTitle}</a></div>
                    </li>
                );
            }
        });



        return(
            <div className={ContentFirmAndPolicySty.firmAndPolicyDiv}>
                <div className={ContentFirmAndPolicySty.lineDiv}>
                    <div className={ContentFirmAndPolicySty.menuDiv}>
                        <ul>
                            {menuLis}
                        </ul>
                        <div className={ContentFirmAndPolicySty.menuMore}><a onClick={()=>{this.onPolicyMoreClick()}}>更多&gt;&gt;</a></div>
                    </div>
                    <div className={ContentFirmAndPolicySty.splitLineSty}></div>
                    <div className={ContentFirmAndPolicySty.contentDiv}>
                        {this.onContentChange()}
                    </div>
                </div>
            </div>

        );

    }
}


const mapStateToProps=(state)=>{
    return {
        policyData:state.aboutPolicyReducer.policyData,
    }
}

const mapDispatchToProps=(dispatch)=>{
    return {
        fetch_policy:(method,params)=>{dispatch(fetch_policy(method,params))},
    }
}


export default connect(mapStateToProps,mapDispatchToProps)(withRouter(ContentFirmAndPolicy));
